import { render, staticRenderFns } from "./fileModal.vue?vue&type=template&id=1928a9d0&scoped=true"
import script from "./fileModal.vue?vue&type=script&lang=js"
export * from "./fileModal.vue?vue&type=script&lang=js"
import style0 from "./fileModal.vue?vue&type=style&index=0&id=1928a9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928a9d0",
  null
  
)

export default component.exports